import { render, staticRenderFns } from "./About_Us.vue?vue&type=template&id=657aaeb4&scoped=true&"
import script from "./About_Us.vue?vue&type=script&lang=js&"
export * from "./About_Us.vue?vue&type=script&lang=js&"
import style0 from "./About_Us.vue?vue&type=style&index=0&id=657aaeb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657aaeb4",
  null
  
)

export default component.exports